export default "__VITE_ASSET__73819c7d__"